module.exports = __webpack_public_path__ + "img/202011_time.e3fea944.svg";